export default class HeroVideo {
  constructor(heroVideo = null) {
    if (!heroVideo) return;

    this.heroVideo = heroVideo;

    this.btnMute = document.querySelector('.js-video-controls .mute-control');
    this.btnPause = document.querySelector('.js-video-controls .pause-control');
    this.hero_video = document.querySelector('.hero-video-wrapper');
    this.has_slideshow = heroVideo.getAttribute('slideshow');
    this.hero_close_btn = document.querySelector('.hero-video-close');
    this.hero_replay_btn = document.querySelector('.hero-video-play');
    this.hero_slogan = document.querySelector('.first-slideshow-slogan');

    this.init();

	this.events();
  }

  toggleSlideshow() {
    this.heroVideo.pause();
    this.heroVideo.muted = true;
    this.hero_video.classList.add('hide-video');
    this.hero_close_btn.classList.add('d-none');
    this.hero_replay_btn.classList.remove('d-none');
  }

  init() {
    if (
      document.getElementById('hero-embed').classList.contains('mobile-video')
    ) {
      this.btnPause.querySelector('.icon').classList.remove('stop');
    }

    this.toggleSlideshow.bind(this)();
  }

  heroReplayBtnClick() {
	  if (this.hero_video.classList.contains('hide-video')) {
		  this.hero_slogan.classList.add('slogan-hide');
		  this.hero_video.classList.remove('hide-video');
		  this.heroVideo.play();
		  this.hero_close_btn.classList.remove('d-none');
		  this.hero_replay_btn.classList.add('d-none');
	  } else {
		  this.hero_video.classList.add('hide-video');
		  this.heroVideo.pause();
		  this.hero_slogan.classList.remove('slogan-hide');
	  }
  }

	heroCloseBtnClick () {
		if (!this.hero_video.classList.contains('hide-video')) {
			this.hero_replay_btn.classList.remove('d-none');
			this.hero_slogan.classList.remove('slogan-hide');
			this.hero_video.classList.add('hide-video');
			this.heroVideo.pause();
			this.hero_close_btn.classList.add('d-none');
			this.hero_replay_btn.classList.remove('d-none');
		} else {
			this.hero_close_btn.classList.remove('d-none');
		}
	}

	btnPauseClick() {
		if (this.heroVideo.paused) {
			this.heroVideo.play();
			this.btnPause.querySelector('.icon').classList.remove('stop');
		} else {
			this.heroVideo.pause();
			this.btnPause.querySelector('.icon').classList.add('stop');
		}
	}

	btnMuteClick() {
		if (this.heroVideo.muted) {
			this.btnMute.querySelector('.icon').classList.add('stop');
		} else {
			this.btnMute.querySelector('.icon').classList.remove('stop');
		}
		this.heroVideo.muted = !this.heroVideo.muted;
	}
  events() {
	  if (this.has_slideshow === '1') {
		  this.heroVideo.addEventListener(
			  'ended',
			  this.toggleSlideshow.bind(this),
			  false
		  );

		  this.hero_replay_btn && this.hero_replay_btn.addEventListener('click', this.heroReplayBtnClick.bind(this), false);
		  this.hero_close_btn && this.hero_close_btn.addEventListener('click', this.heroCloseBtnClick.bind(this), false);
		  this.btnPause.addEventListener('click', this.btnPauseClick.bind(this), false);
		  this.btnMute.addEventListener('click', this.btnMuteClick.bind(this), false);
	  }
  }
}
